var _path, _path2, _path3, _linearGradient, _path4, _path5, _path6, _path7, _linearGradient2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path25, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnekey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    enableBackground: "new 0 0 2000 2000",
    id: "currency-exchange-service",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d5f0ff",
    d: "M897.5 62.8c251.7-16.7 482.1 71.6 636.4 222.6 245 103.5 418.7 317.4 434.1 574.6 22.8 382.2-312.5 715.5-749 744.3-119.7 7.9-234.5-7.9-338.6-42.9-5.5.5-11.1.9-16.7 1.3C427.2 1591.5 55 1305.1 32.1 922.9c-13-218.3 90.8-420.6 263.5-559.3C431 195.5 647.6 79.3 897.5 62.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0643a3",
    fillRule: "evenodd",
    d: "M232.1 889.9h455.7c11.8 0 21.3 9.5 21.3 21.3v780.1c0 11.8-9.5 21.3-21.3 21.3H232.1c-11.7 0-21.3-9.5-21.3-21.3V911.2c-.1-11.7 9.5-21.3 21.3-21.3z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c7efe",
    fillRule: "evenodd",
    d: "M253.6 889.9h435.1c11.2 0 20.4 9.1 20.4 20.3v782.1c0 11.2-9.1 20.3-20.4 20.3H253.6c-11.2 0-20.4-9.1-20.4-20.3V910.2c0-11.2 9.2-20.3 20.4-20.3z",
    clipRule: "evenodd"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 263.18,
    x2: 679.118,
    y1: 1288.259,
    y2: 1288.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26a9e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4dceb"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M281 975.7h380.3c9.8 0 17.8 8 17.8 17.8V1583c0 9.8-8 17.8-17.8 17.8H281c-9.8 0-17.8-8-17.8-17.8V993.5c0-9.8 8-17.8 17.8-17.8z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M420.2 940h101.9c1.3 0 2.4 1.1 2.4 2.4v4c0 1.3-1.1 2.4-2.4 2.4H420.2c-1.3 0-2.4-1.1-2.4-2.4v-4c0-1.4 1.1-2.4 2.4-2.4zM471.1 1693c18.4 0 33.4-15 33.4-33.4s-15-33.4-33.4-33.4-33.4 15-33.4 33.4 15 33.4 33.4 33.4z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c7efe",
    fillRule: "evenodd",
    d: "M471.1 1686.6c14.9 0 27.1-12.1 27.1-27.1 0-14.9-12.2-27.1-27.1-27.1-14.9 0-27.1 12.2-27.1 27.1.1 15 12.2 27.1 27.1 27.1zM1360.8 889.9h455.7c11.7 0 21.3 9.5 21.3 21.3v780.1c0 11.8-9.6 21.3-21.3 21.3h-455.7c-11.7 0-21.3-9.5-21.3-21.3V911.2c0-11.7 9.6-21.3 21.3-21.3z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#84b2fe",
    fillRule: "evenodd",
    d: "M1382.3 889.9h435.1c11.2 0 20.4 9.1 20.4 20.3v782.1c0 11.2-9.1 20.3-20.4 20.3h-435.1c-11.2 0-20.4-9.1-20.4-20.3V910.2c.1-11.2 9.2-20.3 20.4-20.3z",
    clipRule: "evenodd"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1391.92,
    x2: 1807.857,
    y1: 1288.259,
    y2: 1288.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26a9e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4dceb"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M1409.7 975.7H1790c9.8 0 17.8 8 17.8 17.8V1583c0 9.8-8 17.8-17.8 17.8h-380.3c-9.8 0-17.8-8-17.8-17.8V993.5c0-9.8 8-17.8 17.8-17.8z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1548.9 940h101.9c1.3 0 2.4 1.1 2.4 2.4v4c0 1.3-1.1 2.4-2.4 2.4h-101.9c-1.4 0-2.4-1.1-2.4-2.4v-4c0-1.4 1.1-2.4 2.4-2.4zM1599.9 1693c18.4 0 33.4-15 33.4-33.4s-15-33.4-33.4-33.4-33.4 15-33.4 33.4 15 33.4 33.4 33.4z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#84b2fe",
    fillRule: "evenodd",
    d: "M1599.9 1686.6c14.9 0 27.1-12.1 27.1-27.1 0-14.9-12.2-27.1-27.1-27.1-14.9 0-27.1 12.2-27.1 27.1 0 15 12.2 27.1 27.1 27.1z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea718b",
    d: "M730.7 1283.3h57.7v17.8l57.7-35.5-57.7-35.6v17.8h-57.7v35.5zM1214.9 1283.3h57.8v17.8l57.7-35.5-57.7-35.6v17.8h-57.8v35.5zm0-17.7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1247.1 574c-7 0-13.9-3.4-18.2-9.7-38.9-57.2-114.8-94.1-198.2-96.5-83.4-2.4-161.2 30.1-203.1 85-7.5 9.8-21.3 11.6-31 3.9-9.6-7.6-11.4-21.7-3.9-31.5 24.6-32.2 59.5-58.7 100.9-76.6 42.1-18.2 89.9-27.1 138.3-25.7 48.4 1.4 95.6 12.9 136.6 33.5 40.4 20.3 73.8 48.7 96.6 82.3 6.9 10.2 4.4 24.2-5.6 31.3-3.7 2.7-8.1 4-12.4 4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1182.1 633.1c-7 0-13.9-3.4-18.2-9.7-26.1-38.4-77.4-63.3-134-64.9-56.6-1.6-109.2 20.3-137.4 57.2-7.5 9.8-21.3 11.6-31 3.9-9.6-7.6-11.3-21.7-3.9-31.5 18-23.5 43.4-42.8 73.5-55.9 30.4-13.2 65-19.6 99.9-18.6 34.9 1 69 9.4 98.7 24.3 29.4 14.8 53.8 35.5 70.4 60 6.9 10.2 4.4 24.2-5.6 31.2-3.7 2.7-8 4-12.4 4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1029.7 702.2c-21.7-.6-39.8 16.7-40.4 39-.6 22.1 16.4 40.5 38.3 41.1 21.7.6 39.8-16.9 40.4-39 .6-22.1-16.7-40.5-38.3-41.1z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1118.4 694.6c-7 0-13.9-3.4-18.1-9.6-13.7-20.1-41-33.1-71.1-33.9h-.1c-30.2-.9-58.1 10.6-72.8 29.9-7.5 9.8-21.3 11.6-31 4-9.6-7.6-11.4-21.7-3.9-31.5 11.5-15 27.6-27.3 46.7-35.6 19-8.2 40.5-12.2 62.2-11.6 21.8.6 43.1 5.8 61.6 15.1s34 22.5 44.6 38.1c7 10.2 4.5 24.2-5.5 31.3-3.8 2.5-8.2 3.8-12.6 3.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#8dafdc",
    fillRule: "evenodd",
    d: "M1808.7 1632.5c-19.7-10.1-48.4-46.3-52.8-79.7-1.4-10.2-6.1-45.6 14.4-47.8 10.4 6.8 12.9 34.4 31.1 20.3 6.8-9.5-25-14.9-24.9-26.2 2.1-15.2 20.2-38.1 37.9-37 6.2 4.7 6.7 48.7 16.8 48.3 9.4-2.7-5.4-27.3-8.1-40.9-1.3-14 21-19.8 34.2-24.8-6.2 16.9-8 31.9-1.7 33 15.3.8-3.9-24.9 1.7-33 19.1-7.2 21.2-16.6 32.6-13.5 9 11.1 12.9 16.4 14.7 29.9 3.2 29.3-42.5 37.5-36.7 45.6 7.9 4.3 29.7-22.4 34.7-20.1 11 3 14.7 26.3 7.5 33.4-10.7 10.4-49.8 15.6-48.6 23.7 1.4 10.1 43.8-15.6 57.1-4 10.1 10.5 8.4 31.5 4.9 45.3-1 19.5-64-9.9-67-3.4 2.4 18.3 70.1 11.6 57.1 37.9-8.2 13.5-23.2 18.7-38.1 23-22.9 6.2-52.9-2.5-66.8-10zm81.3-81.7c-2.1-1.2-5-.3-6.3 2.1-1.4 2.3-.7 5.3 1.4 6.5 2.1 1.2 5 .3 6.3-2.1 1.4-2.4.7-5.3-1.4-6.5zm-57.2-12.4c1.6 7.3-8 2-9.6-1.8-3-4.2-6.2-10.9-2.9-15.6 6.4-.1 10.2 8.3 12.5 17.4zm-18.2 25.7c5.4-9.6-13.8-21.4-19.1-18.6-4 3.9 13.5 24.2 19.1 18.6zm37.2 36.8c3.6 1.9-2 4-4.2 3.4-2.8-.3-6.8-1.3-7.6-4.4 2.2-2.7 7.1-1.3 11.8 1zm26.1-90.2c-4.4-1.2-9.7 2.3-12.7 5.5.9 3.4 5.7 1.6 8.8.9 3.6-.8 6.6-4.5 3.9-6.4z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#6495ce",
    d: "M1793.4 1703.2c-1.1-.3-1.8-1.5-1.6-2.6 6.8-41.1 17-81.2 30-119.3 14.8-43 33.9-85.1 56.7-125 .6-1.1 2.1-1.5 3.2-.9s1.5 2.1.9 3.2c-43.4 75.7-71.6 155.1-86.2 242.8-.2 1.3-1.4 2.1-2.7 1.9-.1 0-.2 0-.3-.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#6495ce",
    d: "M1850.1 1517.3c-.4-.1-.8-.4-1.1-.7-6.2-7.5-10.2-15.7-11.9-24.4-1.6-8.1-1.2-16.6 1.1-25.5.3-1.3 1.6-2 2.9-1.7 1.3.3 2 1.6 1.7 2.9-4.5 17-1.2 32.3 9.8 45.7.8 1 .7 2.5-.3 3.3-.6.5-1.5.6-2.2.4zM1819.8 1594.8h-.1c-30.4-11.5-48.8-35.5-53.2-69.4-.2-1.3.7-2.5 2-2.6 1.3-.2 2.5.7 2.6 2 4.2 32.1 21.5 54.8 50.2 65.6 1.2.5 1.8 1.8 1.4 3-.5 1.2-1.7 1.8-2.9 1.4zM1853.7 1568.4c-6.8-2.1-13.9-5.2-21.6-9.3-1.1-.6-1.6-2-1-3.2s2-1.6 3.2-1c27 14.3 47.7 16.1 71.6 6.1 1.2-.5 2.6.1 3.1 1.3s-.1 2.6-1.3 3.1c-13.5 5.7-26.3 7.7-39.1 6.2-4.9-.6-9.8-1.6-14.9-3.2zM1832.2 1625.5c-7.7-2.4-14.1-5.9-19.6-9.5-1.1-.7-1.4-2.2-.7-3.3s2.2-1.4 3.3-.7c15.3 10.1 38.2 19.4 79.3 2.6 1.2-.5 2.6.1 3.1 1.3s-.1 2.6-1.3 3.1c-28.7 11.7-49 11.3-64.1 6.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfe4f3",
    fillRule: "evenodd",
    d: "M1759.2 1640.9c-21.4 5.6-66.9-2.6-92.3-24.7-7.9-6.7-34.9-30-20.9-45.3 12.3-1.8 32.4 17.2 36.8-5.5-1.2-11.6-28.6 5.5-36-3.1-8.5-12.9-10.2-41.9 3.8-52.8 7.8-.6 37.3 32 44.7 25 5.3-8.3-22.1-16.8-33.2-25.3-10.2-9.6 2.5-28.8 9.2-41.2 6.6 16.8 15.1 29.2 20.6 25.8 12-9.5-19.4-16-20.6-25.8 9.5-18.1 4.8-26.5 15.4-31.8 14.1 2.3 20.5 3.8 30.8 12.7 21.8 19.8-7 56.3 2.7 58.5 8.8-2 7.4-36.5 12.6-38 10.2-5.1 28.5 10 27.7 20-1.1 14.8-26.8 44.7-20.6 50 7.8 6.6 22.5-40.7 40.1-40.9 14.5 1.2 27.2 18 33.7 30.6 12.2 15.3-54.4 35.1-52.4 41.9 13.9 12.1 60.1-37.8 67.8-9.5 2.8 15.6-4.9 29.4-13.3 42.5-13 20-41.2 33.4-56.6 36.9zm6.6-115c-2.4.5-3.9 3.1-3.3 5.7.5 2.7 3 4.4 5.4 3.9 2.4-.5 3.9-3.1 3.4-5.7-.7-2.7-3.1-4.4-5.5-3.9zm-51 28.6c6 4.4-4.7 6.7-8.4 5-5-1.1-11.8-4.1-12.5-9.8 4.7-4.3 13.1-.5 20.9 4.8zm3.4 31.4c-2.3-10.7-24.5-6.9-26.7-1.3-.3 5.6 26.2 9.1 26.7 1.3zm52.3 2.9c4-1 1.1 4.4-.9 5.3-2.3 1.7-6 3.5-8.6 1.7-.1-3.5 4.5-5.7 9.5-7zm-40.3-85c-4.2 2-5.7 8.1-5.9 12.5 2.9 1.9 5.4-2.6 7.2-5.3 2.2-2.7 1.9-7.5-1.3-7.2z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#8dafdc",
    d: "M1792.8 1704.7c-.6-.2-1.2-.6-1.6-1.2-22.1-35.3-41.2-72-56.7-109.3-17.5-42-31.1-86.2-40.4-131.3-.3-1.6.7-3.1 2.3-3.5 1.6-.3 3.1.7 3.5 2.3 17.7 85.4 49.2 163.5 96.4 238.7.9 1.4.4 3.2-.9 4.1-1 .4-1.9.4-2.6.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#8dafdc",
    d: "M1703.6 1526c-6.1-1.9-11.6-4.7-16.5-8.5-6.6-5.1-12.1-11.8-16.2-20-.7-1.5-.1-3.2 1.3-4 1.5-.7 3.2-.1 4 1.3 7.8 15.5 20.3 24.7 37.2 27.4 1.6.3 2.7 1.8 2.4 3.4-.3 1.6-1.8 2.7-3.4 2.4-3.1-.5-6-1.2-8.8-2zM1689.3 1608.3c-11.6-3.6-22.7-10-33.2-19.2-1.2-1.1-1.4-2.9-.3-4.2 1.1-1.2 2.9-1.4 4.2-.3 24.3 21.1 52.1 26.6 80.5 15.8 1.5-.6 3.2.2 3.8 1.7.6 1.5-.2 3.2-1.7 3.8-18.2 7-36.2 7.8-53.3 2.4zM1726.5 1571c-1-.3-1.7-1.1-2-2.1-.4-1.6.6-3.2 2.2-3.6 29.5-7.2 46.1-19.5 57.2-42.6.7-1.5 2.5-2.1 3.9-1.4 1.5.7 2.1 2.5 1.4 3.9-6.4 13.3-14.7 23.4-25.4 30.8-9.3 6.5-20.7 11.2-35.8 14.9-.4.3-1 .3-1.5.1zM1749.9 1626.5c-1-.3-1.9-1.2-2-2.4-.2-1.6.9-3.1 2.5-3.3 18-2.6 41.1-10.7 60.6-50.3.7-1.5 2.5-2.1 3.9-1.3 1.5.7 2.1 2.5 1.3 3.9-9.4 19.1-20.3 32.8-33.3 41.7-11.9 8.2-23.2 10.6-31.7 11.9-.5 0-.9-.1-1.3-.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#15489d",
    fillRule: "evenodd",
    d: "m1790.4 1726.8 20.1 27.6 20 27.6h-80.2l20-27.6z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b76ba",
    fillRule: "evenodd",
    d: "M1896.1 1679.6c-4.4 51.3-50.1 91.6-105.7 91.6-55.7 0-101.3-40.3-105.7-91.6h211.4z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1768.3 1762.5c-38.7-8.1-68.1-39.1-71.4-77.1h10.2c5.1 34.4 28.7 63.2 61.2 77.1z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8dafdc",
    fillRule: "evenodd",
    d: "M155.3 1397.6c12.5-6.6 24.6 7.1 29.9 17.6 5.2 10.6 8.1 23.6 3.5 32.9-10.3.6-21.6-7.4-28.8-16.1-7.3-8.8-15-25.2-4.6-34.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d80bc",
    d: "m223.6 1739.3-3.4-1.3c20.3-53.1 3.8-95.4-13.7-140.1-10.7-27.3-21.7-55.4-24.7-87.3-3.4-36 4.1-71.8 23.1-109.5l3.3 1.6c-41.7 82.7-19.6 139.2 1.7 193.8 17.7 45.5 34.5 88.4 13.7 142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8dafdc",
    fillRule: "evenodd",
    d: "M231.8 1461.1c-9.4-10.5-25.6-1.8-34.1 6.4-8.5 8.1-15.7 19.3-14.6 29.6 9.5 4.1 22.8.5 32.6-5.2s22.6-18.6 16.1-30.8zM137.4 1521.7c7.8-11.8 25-5.5 34.7 1.2 9.7 6.8 18.4 16.8 18.8 27.2-8.8 5.5-22.4 3.8-33-.4-10.6-4.2-25.2-15-20.5-28zM247.1 1553.5c-11.9-7.6-25.1 5.1-31.2 15.2-6.1 10.1-10 22.9-6.2 32.5 10.3 1.4 22.1-5.6 30.1-13.7 8-8.2 16.9-24 7.3-34zM174.3 1630.1c7.8-11.8 25-5.5 34.7 1.3 9.7 6.7 18.4 16.8 18.8 27.1-8.8 5.5-22.4 3.9-33-.4-10.6-4.1-25.2-14.9-20.5-28zM243.8 1369.7c-11-8.8-25.5 2.3-32.7 11.7-7.1 9.3-12.4 21.6-9.6 31.6 10.1 2.6 22.6-3.2 31.4-10.4s19.3-21.9 10.9-32.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#dccde4",
    fillRule: "evenodd",
    d: "M196.7 1454.4c10-4.2 18.3 7.2 21.5 15.6 3.2 8.4 4.5 18.5.4 25.2-7.9-.3-15.9-7.1-20.8-14.3-5-7.1-9.7-20.2-1.1-26.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d80bc",
    d: "m225.3 1719.6-3.3-1.6c19.1-38.9 9.5-72.1-.7-107.4-6.2-21.5-12.7-43.8-12.8-68.3-.1-27.8 8.2-54.6 25.3-82l3.1 1.9c-37.4 59.9-24.6 104.4-12.1 147.4 10.4 35.9 20.2 69.9.5 110z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dccde4",
    fillRule: "evenodd",
    d: "M250.5 1508.1c-6.5-8.7-19.4-3.1-26.4 2.5-7.1 5.6-13.4 13.6-13.2 21.6 7 3.8 17.3 1.9 25.2-1.7 7.9-3.7 18.6-12.6 14.4-22.4zM174.4 1547.6c6.7-8.4 19.4-2.5 26.3 3.3 6.9 5.8 12.8 14.1 12.4 22-7.1 3.5-17.4 1.4-25.1-2.6-7.8-3.8-18.1-13.1-13.6-22.7zM255.7 1579.5c-8.5-6.6-19.5 2.1-24.8 9.4-5.3 7.3-9.2 16.7-6.9 24.3 7.7 1.8 17.2-2.7 23.9-8.4 6.6-5.6 14.5-17 7.8-25.3zM195 1632.8c6.7-8.5 19.5-2.5 26.4 3.3 6.8 5.8 12.8 14.1 12.4 22-7 3.6-17.4 1.4-25.1-2.6-7.8-3.8-18.2-13.1-13.7-22.7zM266 1439.4c-7.7-7.5-19.6 0-25.7 6.6-6.1 6.6-11 15.6-9.5 23.4 7.5 2.7 17.4-.8 24.6-5.7 7.2-4.9 16.3-15.4 10.6-24.3z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8dafdc",
    fillRule: "evenodd",
    d: "M285.3 1629c-6.3-10.8-21.8-6.2-30.7-.7-8.9 5.5-17.2 13.9-18 23.1 7.5 5.3 19.7 4.5 29.2 1.4 9.5-3.2 23-12 19.5-23.8zM314 1424.3c-10.7-6.5-22.1 5-27.3 14.1-5.2 9.1-8.4 20.4-4.8 28.9 9.1 1 19.5-5.4 26.4-12.8 6.8-7.4 14.4-21.5 5.7-30.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d80bc",
    d: "M236 1723.1c-15.7-49.3 1.4-86.4 19.4-125.7 21.7-47.2 44-96 11.4-171.1l3.3-1.5c14.9 34.3 19.8 66.4 14.9 98.1-4.3 28-15.5 52.4-26.3 76-17.7 38.7-34.5 75.2-19.3 123.1l-3.4 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8dafdc",
    fillRule: "evenodd",
    d: "M243.1 1476.6c8.9-8.8 22.7-.3 29.9 7.4 7.2 7.6 12.9 17.9 11.4 26.9-8.6 3.2-20.2-.7-28.6-6.3-8.4-5.5-19.2-17.5-12.7-28zM323.5 1535c-6.3-10.9-21.8-6.2-30.7-.7-8.9 5.5-17.1 13.9-18 23 7.5 5.3 19.7 4.5 29.2 1.4 9.5-3.2 23-12 19.5-23.7zM224.8 1557.5c10.9-6.1 21.9 5.8 26.8 15 4.9 9.2 7.7 20.7 3.8 29-9.2.8-19.3-6.1-25.9-13.7-6.6-7.5-13.7-21.9-4.7-30.3zM237.1 1395.2c10.2-7.3 22.4 3.3 28.2 12 5.8 8.7 9.9 19.7 6.9 28.5-9 1.7-19.8-4-27.2-10.8-7.3-6.9-16-20.4-7.9-29.7z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#dccde4",
    fillRule: "evenodd",
    d: "M376.9 1501.9c-6.9-8.3-19.5-2.1-26.2 3.9-6.8 6-12.6 14.4-12 22.2 7.2 3.4 17.4 1 25.1-3.1 7.6-4 17.8-13.5 13.1-23z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d80bc",
    d: "m232.9 1724.2-3.6-.1c1-44.7 25.4-70.3 51.2-97.4 30.9-32.4 62.8-65.9 57.2-136.4l3.6-.3c2.6 32.3-2.5 59.9-15.3 84.5-11.4 21.7-27.4 38.5-42.8 54.7-25.5 26.6-49.3 51.7-50.3 95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dccde4",
    fillRule: "evenodd",
    d: "M304.4 1524.8c9.7-4.7 18.6 6.2 22.3 14.4 3.7 8.2 5.5 18.2 1.7 25.2-7.9.2-16.3-6.3-21.6-13.2-5.2-6.9-10.6-19.7-2.4-26.4zM353.7 1594.9c-2.1-10.6-16.1-11.2-24.9-9.2-8.8 2-17.9 6.6-21.1 13.8 4.6 6.4 14.8 9.2 23.5 9.3 8.6.2 22.1-3.3 22.5-13.9zM266.8 1585.7c10.6-1.9 16.3 10.9 17.7 19.8 1.4 8.9.5 19.1-5.1 24.7-7.7-1.9-14-10.3-17.3-18.4-3.2-8-5-21.8 4.7-26.1zM296.1 1661c-2.1-10.6-16.1-11.2-24.9-9.2-8.8 2-17.9 6.6-21.1 13.8 4.6 6.4 14.8 9.2 23.5 9.3 8.7.2 22.1-3.3 22.5-13.9zM322.3 1456.6c10.3-3.1 17.4 9 19.7 17.7 2.3 8.7 2.5 18.9-2.3 25.1-7.8-1.1-15.1-8.8-19.2-16.4-4.1-7.6-7.3-21.1 1.8-26.4z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#dccde4",
    fillRule: "evenodd",
    d: "M96.8 1481.1c8.2-8.2 21-.3 27.6 6.7 6.6 7 12 16.5 10.6 24.9-8 2.9-18.7-.6-26.4-5.7-7.8-5.2-17.8-16.3-11.8-25.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d80bc",
    d: "m232 1732.4-3.6-.3c3.2-46.3-19.8-75.4-44.1-106.2-14.9-18.8-30.2-38.3-40.2-62.5-11.3-27.4-13.9-57.3-8-91.4l3.6.6c-13 74.5 17.8 113.4 47.5 151.1 24.8 31.4 48.2 61 44.8 108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dccde4",
    fillRule: "evenodd",
    d: "M171.8 1512.6c-9.9-6-20.5 4.7-25.2 13.1-4.8 8.4-7.7 18.9-4.3 26.7 8.4 1 18-5 24.3-11.9 6.2-6.8 13.3-19.9 5.2-27.9zM112.3 1582.5c3.3-11.1 18.3-10.3 27.4-7.3 9.2 3 18.4 8.8 21.2 16.8-5.6 6.4-16.7 8.4-25.9 7.6-9.2-.8-23.3-5.8-22.7-17.1zM205.8 1581.3c-11.1-3.1-18.5 10-20.8 19.3-2.3 9.3-2.3 20.3 2.9 26.9 8.4-1.4 16-9.7 20.3-18 4.3-8.2 7.6-22.7-2.4-28.2zM167.1 1658.6c3.3-11.1 18.3-10.3 27.4-7.3 9.2 3 18.4 8.8 21.2 16.8-5.6 6.4-16.7 8.4-25.9 7.6-9.3-.8-23.3-5.7-22.7-17.1zM159.4 1438.2c-10.7-4.3-19.4 7.9-22.8 17-3.4 9-4.6 19.9 0 27 8.5-.4 16.9-7.8 22-15.6 5.3-7.8 10.1-21.8.8-28.4z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fbb445",
    fillRule: "evenodd",
    d: "m256 1798.1 6.6-19.4 29.3-86.4H174.6l29.3 86.4 6.6 19.4h26.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f39d20",
    fillRule: "evenodd",
    d: "M174.7 1686.5h118.1c3.2 0 5.8 2.6 5.8 5.8v.4c0 3.2-2.6 5.8-5.8 5.8H174.7c-3.2 0-5.8-2.6-5.8-5.8v-.4c0-3.2 2.6-5.8 5.8-5.8z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a4c839",
    fillRule: "evenodd",
    d: "M1561.3 1144.4c-4.4 10.4-22.8 19-25.6 35.5-2.9 16.7 2.2 32.5 12.2 42.2 12.6-5.7 22.8-19 25.7-35.6 2.8-16.7-2.4-32.5-12.3-42.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4c839",
    d: "m1547.8 1222.4-.1-.1c-10.4-10-15.1-26.3-12.3-42.4 1.7-10 9.1-17.1 15.6-23.4 4.3-4.1 8.3-8 10.1-12.1l.1-.3.2.2c10.3 10 15.1 26.2 12.4 42.3-2.8 16.1-12.7 29.8-25.8 35.8h-.2zm13.5-77.6c-1.9 4.1-5.8 7.9-10 12-6.5 6.2-13.8 13.3-15.5 23.2-2.8 15.9 1.8 32 12 41.9 12.9-5.9 22.7-19.5 25.5-35.4 2.7-15.9-1.9-31.8-12-41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4c839",
    fillRule: "evenodd",
    d: "M1467.8 1224c11.1-2.7 22.5-19.5 39.3-19.6 16.9-.2 31.8 7.4 39.6 18.9-7.7 11.6-22.4 19.5-39.3 19.6-16.9.1-31.6-7.5-39.6-18.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4c839",
    d: "M1506.9 1243.1c-16.1 0-31.1-7.2-39.3-19l-.2-.3.3-.1c4.4-1.1 8.9-4.4 13.7-8 7.3-5.4 15.5-11.5 25.6-11.6h.5c16.2 0 31.2 7.2 39.3 19l.1.1-.1.1c-8 12-23.1 19.6-39.5 19.7 0 .1-.2.1-.4.1zm-38.7-19c8.2 11.6 23.2 18.7 39.3 18.5 16.2-.1 31.1-7.5 39-19.3-8.1-11.7-23.2-18.8-39.4-18.7-10 .1-18.2 6.1-25.4 11.5-4.7 3.5-9.1 6.8-13.5 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8ea14",
    fillRule: "evenodd",
    d: "M1463.1 1222.7c15.5-80.4 93-133 173.4-117.6 80.4 15.4 133 93 117.6 173.4-15.5 80.3-93 133-173.4 117.5-80.3-15.4-133-93-117.6-173.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8ea14",
    d: "M1609 1398.9c-9.4 0-18.9-.9-28.3-2.7-38.9-7.4-72.6-29.6-94.8-62.4-22.2-32.8-30.4-72.3-22.9-111.1 7.5-38.9 29.7-72.6 62.4-94.8 32.8-22.2 72.3-30.4 111.2-22.9 38.9 7.4 72.6 29.6 94.8 62.4 22.2 32.8 30.4 72.3 22.9 111.2-7.5 38.9-29.7 72.6-62.4 94.8-24.9 16.8-53.5 25.5-82.9 25.5zm-145.7-176.1c-7.4 38.8.7 78.1 22.9 110.8s55.8 54.8 94.6 62.2c9.4 1.8 18.7 2.7 28 2.7 69.4 0 131.6-49.3 145.2-120 7.4-38.8-.7-78.2-22.9-110.9s-55.8-54.8-94.6-62.2c-80.1-15.4-157.8 37.3-173.2 117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8cd12",
    fillRule: "evenodd",
    d: "M1478.7 1225.6c14.6-76 88.1-125.8 164.2-111.3 76 14.6 125.8 88.1 111.3 164.2-14.6 76-88.1 125.9-164.2 111.3-76.1-14.6-125.9-88.1-111.3-164.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8cd12",
    d: "M1616.7 1392.5c-8.9 0-17.8-.8-26.8-2.6-36.8-7.1-68.7-28.1-89.7-59.1s-28.8-68.4-21.7-105.3c7.1-36.8 28.1-68.7 59.1-89.7s68.4-28.8 105.3-21.7c36.8 7.1 68.7 28.1 89.7 59.1s28.8 68.4 21.7 105.3c-7.1 36.8-28.1 68.7-59.1 89.8-23.5 16-50.7 24.2-78.5 24.2zm-137.8-166.8c-14.5 75.8 35.4 149.4 111.1 163.9 8.9 1.7 17.7 2.5 26.4 2.5 65.8 0 124.6-46.7 137.5-113.6 14.5-75.8-35.4-149.3-111.1-163.9-75.8-14.5-149.4 35.3-163.9 111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1616.3 1383c72.2 0 131-58.8 131-130.9 0-72.2-58.8-131-131-131-72.1 0-130.9 58.8-130.9 131 0 72.1 58.9 130.9 130.9 130.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1616.3 1383.2c-34.9 0-67.8-13.7-92.6-38.5-24.8-24.8-38.5-57.7-38.5-92.7 0-72.4 58.8-131.2 131.1-131.2 72.4 0 131.2 58.9 131.2 131.2.1 72.4-58.8 131.2-131.2 131.2zm0-261.9c-72.1 0-130.7 58.7-130.7 130.8 0 72.1 58.6 130.7 130.7 130.7s130.8-58.6 130.8-130.7-58.6-130.8-130.8-130.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d48929",
    fillRule: "evenodd",
    d: "M1616.3 1380.2c70.6 0 128.1-57.6 128.1-128.1 0-70.6-57.5-128.1-128.1-128.1-70.5 0-128.1 57.5-128.1 128.1 0 70.5 57.6 128.1 128.1 128.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d48929",
    d: "M1616.3 1380.4c-70.8 0-128.3-57.6-128.3-128.3 0-70.8 57.6-128.3 128.3-128.3s128.3 57.6 128.3 128.3c.1 70.8-57.5 128.3-128.3 128.3zm0-256.2c-70.5 0-127.9 57.4-127.9 127.9s57.4 127.9 127.9 127.9 127.9-57.4 127.9-127.9-57.3-127.9-127.9-127.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f8cd12",
    fillRule: "evenodd",
    d: "M1616.3 1377.8c69.3 0 125.7-56.5 125.7-125.7 0-69.3-56.5-125.7-125.7-125.7s-125.7 56.5-125.7 125.7 56.6 125.7 125.7 125.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8cd12",
    d: "M1616.3 1378c-33.5 0-65.1-13.1-89-37-23.8-23.8-37-55.4-37-89 0-69.4 56.5-125.9 125.9-125.9s125.9 56.5 125.9 125.9-56.3 126-125.8 126zm0-251.4c-69.2 0-125.5 56.3-125.5 125.5s56.3 125.5 125.5 125.5 125.5-56.3 125.5-125.5-56.3-125.5-125.5-125.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m1519.6 1151.9 2.1 31.4 31.4 2.2-31.4 2.1-2.1 31.4-2.2-31.4-31.3-2.1 31.3-2.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1519.4 1219-2.1-31.2-31.2-2.1v-.4l31.2-2.1 2.1-31.2h.4l2.1 31.2 31.2 2.1v.4l-31.2 2.1-2.1 31.2h-.4zm-30.1-33.5 28.4 1.9 1.9 28.4 1.9-28.4 28.4-1.9-28.4-1.9-1.9-28.4-1.9 28.4-28.4 1.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1686.4 1310.7c0 2.1-.1 4-.1 5.6-.1 1.6-.4 2.9-.6 3.9-.4 1.1-.7 2-1.2 2.9-.4.8-1.4 2-3 3.6-1.5 1.6-4.2 3.5-8 5.9-3.8 2.4-8 4.4-12.8 6.2-4.7 1.9-9.8 3.4-15.3 4.4-5.5 1.1-11.3 1.7-17.1 1.7-12.3 0-23.1-1.9-32.5-6-9.4-3.9-17.3-9.8-23.6-17.6-6.3-7.7-11.2-17.2-14.5-28.4-1.6-5.1-2.7-10.5-3.5-16.3h-18.8c-2.4 0-4.4-2-4.4-4.4v-8.9c0-2.4 2-4.4 4.4-4.4h17.4c-.1-1.6-.1-3.2-.1-4.8 0-3 .1-6 .2-8.9h-17.6c-2.4 0-4.4-2-4.4-4.4v-8.9c0-2.4 2-4.4 4.4-4.4h19.4c.9-5.9 2.3-11.3 4-16.3 4.1-12 9.7-21.8 16.8-29.5 7.2-7.7 15.5-13.3 25.1-17 9.6-3.7 20.1-5.6 31.2-5.6 5.4 0 10.6.6 15.7 1.6 5.1.9 9.7 2.3 14 3.9 4.2 1.6 8.1 3.5 11.4 5.7 3.3 2.1 5.8 4 7.2 5.5 1.6 1.5 2.6 2.7 3.2 3.6.5.9 1 1.9 1.4 3.2.3 1.1.6 2.5.7 4 .1 1.5.1 3.4.1 5.7 0 4.9-.6 8.3-1.6 10.3-1.1 1.9-2.5 2.9-4.2 2.9-1.9 0-4.1-1-6.5-3.2-2.4-2-5.5-4.4-9.3-6.9-3.8-2.5-8.3-4.8-13.7-6.9-5.3-2.1-11.6-3.2-18.9-3.2-15 0-26.4 5.7-34.4 17.3-4.6 6.6-7.9 14.8-9.8 24.9h78.8c2.4 0 4.4 2 4.4 4.4v8.9c0 2.4-1.9 4.4-4.4 4.4h-80.8c-.1 2.3-.1 4.7-.1 7.2 0 2.2 0 4.4.1 6.4h80.8c2.4 0 4.4 2 4.4 4.4v8.9c0 2.4-1.9 4.4-4.4 4.4H1587c.3 1.5.6 3 1 4.4 2.1 8.2 5.2 15 9.2 20.6 4 5.4 9 9.6 14.8 12.3 5.9 2.7 12.5 4.1 20.1 4.1 7.2 0 13.5-1.1 18.9-3.4 5.4-2.2 10-4.7 14-7.5 3.9-2.7 7.3-5.2 10-7.3 2.7-2.2 4.8-3.4 6.3-3.4.9 0 1.6.3 2.3.8.6.5 1.1 1.4 1.6 2.5.4 1.2.8 2.7 1 4.6.1 1.9.2 4 .2 6.5z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a5ca39",
    fillRule: "evenodd",
    d: "M411.3 1143.1c-4.6 10.7-23.4 19.5-26.3 36.5-3 17.1 2.3 33.4 12.5 43.3 13-5.9 23.4-19.5 26.4-36.6 2.9-17.1-2.4-33.3-12.6-43.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5ca39",
    d: "m397.4 1223.1-.1-.1c-10.7-10.3-15.5-27-12.6-43.5 1.8-10.3 9.3-17.6 16-24.1 4.4-4.2 8.5-8.2 10.3-12.5l.1-.3.2.2c10.6 10.3 15.5 26.9 12.7 43.4-2.9 16.6-13.1 30.6-26.5 36.7l-.1.2zm13.9-79.7c-1.9 4.2-6 8.2-10.3 12.3-6.6 6.4-14.1 13.7-15.9 23.8-2.9 16.4 1.9 32.8 12.4 43 13.3-6.1 23.3-20 26.1-36.3 2.8-16.2-1.9-32.6-12.3-42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5ca39",
    fillRule: "evenodd",
    d: "M315.3 1224.8c11.4-2.8 23.1-20 40.3-20.1 17.4-.2 32.6 7.6 40.7 19.4-7.9 11.9-23 20-40.3 20.1-17.4.2-32.5-7.6-40.7-19.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5ca39",
    d: "M355.4 1244.4c-16.5 0-32-7.4-40.3-19.5l-.2-.3.3-.1c4.5-1.1 9.2-4.6 14.1-8.2 7.4-5.5 15.9-11.8 26.3-11.9h.6c16.6 0 32 7.4 40.3 19.5l.1.1-.1.1c-8.2 12.4-23.7 20.1-40.5 20.2-.2.1-.4.1-.6.1zm-39.7-19.5c8.4 11.9 23.8 19.2 40.3 19 16.6-.1 32-7.7 40.1-19.9-8.3-12-23.8-19.4-40.4-19.2-10.3.1-18.7 6.3-26.1 11.8-4.9 3.7-9.4 7.1-13.9 8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faec16",
    fillRule: "evenodd",
    d: "M310.5 1223.5c15.9-82.5 95.5-136.6 178-120.8 82.5 15.8 136.6 95.5 120.8 178-15.9 82.4-95.5 136.6-178 120.7-82.6-15.7-136.6-95.5-120.8-177.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faec16",
    d: "M460.3 1404.5c-9.7 0-19.4-.9-29.1-2.8-40-7.6-74.6-30.4-97.4-64.1-22.8-33.7-31.2-74.2-23.6-114.1 7.7-40 30.5-74.6 64.1-97.4 33.7-22.8 74.2-31.2 114.2-23.6 40 7.6 74.6 30.4 97.4 64.1 22.8 33.7 31.2 74.2 23.6 114.2-7.7 40-30.5 74.5-64.1 97.4-25.5 17.3-55 26.3-85.1 26.3zm-149.6-181c-7.6 39.8.7 80.2 23.5 113.8 22.8 33.6 57.3 56.3 97.1 63.9 9.6 1.9 19.2 2.7 28.7 2.7 71.3 0 135.1-50.6 149.1-123.3 7.6-39.9-.7-80.3-23.5-113.9-22.8-33.6-57.3-56.3-97.1-63.9-82.2-15.6-162 38.5-177.8 120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9ce0d",
    fillRule: "evenodd",
    d: "M326.4 1226.5c15-78.1 90.4-129.2 168.6-114.3 78.1 15 129.2 90.4 114.3 168.6-15 78.1-90.4 129.3-168.6 114.3-78-15.1-129.2-90.5-114.3-168.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9ce0d",
    d: "M468.2 1397.9c-9.1 0-18.3-.9-27.5-2.6-37.8-7.3-70.5-28.8-92.1-60.7-21.6-31.9-29.5-70.3-22.3-108.1 7.3-37.8 28.8-70.5 60.7-92.1 31.9-21.6 70.3-29.5 108.1-22.3 37.8 7.3 70.5 28.8 92.1 60.7 21.6 31.9 29.5 70.3 22.3 108.1-7.3 37.8-28.8 70.6-60.7 92.2-24.2 16.3-52.1 24.8-80.6 24.8zm-141.5-171.4c-14.9 77.9 36.3 153.4 114.1 168.3 9.1 1.7 18.2 2.6 27.1 2.6 67.6 0 128-47.9 141.2-116.7 14.9-77.9-36.3-153.4-114.1-168.3-77.9-14.9-153.4 36.3-168.3 114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M467.8 1388.1c74.1 0 134.5-60.4 134.5-134.5s-60.4-134.5-134.5-134.5c-74 0-134.5 60.4-134.5 134.5.1 74.1 60.5 134.5 134.5 134.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M467.8 1388.3c-35.9 0-69.7-14-95.1-39.5-25.5-25.5-39.5-59.3-39.5-95.1 0-74.3 60.4-134.8 134.7-134.8 74.3 0 134.8 60.5 134.8 134.8-.1 74.2-60.6 134.6-134.9 134.6zm0-269c-74 0-134.2 60.3-134.2 134.3 0 74 60.2 134.2 134.2 134.2 74.1 0 134.3-60.2 134.3-134.2 0-74-60.2-134.3-134.3-134.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d58a28",
    fillRule: "evenodd",
    d: "M467.8 1385.2c72.5 0 131.6-59.1 131.6-131.6s-59-131.6-131.6-131.6c-72.4 0-131.6 59-131.6 131.6.1 72.5 59.2 131.6 131.6 131.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d58a28",
    d: "M467.8 1385.4c-72.7 0-131.8-59.1-131.8-131.8 0-72.7 59.1-131.8 131.8-131.8s131.8 59.1 131.8 131.8c0 72.7-59.1 131.8-131.8 131.8zm0-263.1c-72.4 0-131.3 58.9-131.3 131.3s58.9 131.3 131.3 131.3 131.3-58.9 131.3-131.3c.1-72.4-58.9-131.3-131.3-131.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f9ce0d",
    fillRule: "evenodd",
    d: "M467.8 1382.8c71.1 0 129.1-58.1 129.1-129.1 0-71.1-58-129.1-129.1-129.1-71 0-129.1 58-129.1 129.1 0 71 58.1 129.1 129.1 129.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9ce0d",
    d: "M467.8 1383c-34.4 0-66.9-13.5-91.4-38s-38-56.9-38-91.4c0-71.3 58-129.3 129.3-129.3 71.3 0 129.3 58 129.3 129.3.2 71.4-57.9 129.4-129.2 129.4zm0-258.2c-71.1 0-128.9 57.8-128.9 128.9 0 71.1 57.8 128.9 128.9 128.9s128.9-57.8 128.9-128.9c0-71.1-57.8-128.9-128.9-128.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M529.5 1293.4c0 8.9-1.7 16.8-4.9 23.9-3.3 6.9-8 12.8-14 17.5-6.1 4.7-13.2 8.4-21.7 10.9-3.6 1-7.3 1.8-11.1 2.5v12.5c0 3.3-2.6 6-5.9 6h-8c-3.2 0-5.9-2.6-5.9-6v-11.3c-5.1-.1-9.9-.6-14.5-1.4-5.6-.9-10.7-2.1-15.2-3.6-4.4-1.5-8.2-3-11.3-4.6-3.1-1.6-5.4-3.1-6.7-4.3-1.5-1.3-2.5-3.2-3.2-5.4-.6-2.3-1-5.4-1-9.5 0-2.5.1-4.6.4-6.1.3-1.8.6-3.1 1-4.1.4-1.1 1-1.8 1.7-2.3.7-.4 1.5-.6 2.5-.6 1.3 0 3.5.9 6.2 2.6 2.8 1.8 6.2 3.6 10.3 5.7 4 2 8.9 3.9 14.4 5.6 4.6 1.5 9.7 2.4 15.4 2.6v-61l-3.8-1.5c-5.4-2.2-10.7-4.6-16-7.5-5.2-2.7-9.8-6.1-14-10.2-4-4-7.4-8.8-9.8-14.3-2.5-5.5-3.8-12.2-3.8-20 0-6.8 1.3-13.3 3.9-19.6 2.6-6.3 6.6-11.8 11.8-16.5 5.4-4.6 12-8.5 19.9-11.3 3.6-1.3 7.5-2.3 11.7-3v-12.5c0-3.3 2.6-6 5.9-6h8c3.2 0 5.9 2.6 5.9 6v11.3c3.4.2 6.8.5 10.3 1.1 4.6.8 8.8 1.8 12.5 3.1 3.8 1.1 6.9 2.5 9.6 3.9 2.6 1.5 4.7 2.6 6.1 3.8 1.3 1.1 2.2 2 2.6 2.7.5.8.9 1.7 1.1 2.6.2 1 .4 2.1.6 3.5.2 1.5.3 3.2.3 5.2 0 2.2-.1 4.1-.3 5.7-.3 1.6-.5 2.9-1.1 3.9-.4 1.1-1 1.8-1.7 2.2-.6.4-1.3.7-2.1.7-1.1 0-2.8-.8-5.1-2.2-2.1-1.4-5-2.9-8.5-4.6-3.5-1.7-7.5-3.2-12.3-4.6-3.6-1.1-7.6-1.8-12.1-2v56.8l7.5 3c5.5 2.2 10.9 4.6 16.2 7.4 5.4 2.7 10.2 6.1 14.2 9.8 4.2 3.9 7.5 8.6 10 13.9 2.8 5.6 4 12.1 4 19.6zm-51.8 28.4c3.9-1.1 7.1-2.7 10-4.8 3.2-2.2 5.7-5.1 7.5-8.6 1.8-3.5 2.6-7.7 2.6-12.5 0-4.9-1.3-9.1-3.8-12.4-2.5-3.4-5.9-6.4-9.9-8.9-2-1.2-4.1-2.5-6.4-3.5v50.7zM458 1185.2c-3.6 1.1-6.5 2.7-8.9 4.7-2.6 2.3-4.6 4.9-6 8-1.4 3.1-2.1 6.4-2.1 10 0 5 1.4 9.2 3.9 12.6 2.5 3.5 5.9 6.4 10 9 1 .5 1.9 1.1 3 1.7v-46z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m368.4 1150.8 2.2 32.3 32.3 2.1-32.3 2.2-2.2 32.2-2.1-32.2-32.2-2.2 32.2-2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m368.2 1219.6-2.2-32-32-2.2v-.4l32-2.2 2.2-32.1h.4l2.2 32.1 32.1 2.2v.4l-32.1 2.2-2.2 32h-.4zm-30.9-34.4 29.1 2 2 29.1 2-29.1 29.2-2-29.2-2-2-29.2-2 29.2-29.1 2z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a4c839",
    fillRule: "evenodd",
    d: "M983.6 1148.9c-4.4 10.4-22.8 19-25.6 35.5-2.9 16.7 2.2 32.5 12.2 42.2 12.6-5.7 22.8-19 25.7-35.6 2.9-16.6-2.3-32.4-12.3-42.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4c839",
    d: "m970.2 1226.9-.1-.1c-10.4-10-15.1-26.3-12.3-42.4 1.7-10 9.1-17.1 15.6-23.4 4.3-4.1 8.3-8 10.1-12.1l.1-.3.2.2c10.3 10 15.1 26.2 12.4 42.3-2.8 16.1-12.7 29.8-25.8 35.8h-.2zm13.5-77.6c-1.9 4.1-5.8 7.9-10 12-6.5 6.2-13.8 13.3-15.5 23.2-2.8 15.9 1.8 32 12 41.9 12.9-5.9 22.7-19.5 25.5-35.4 2.7-15.9-1.9-31.8-12-41.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a4c839",
    fillRule: "evenodd",
    d: "M890.2 1228.5c11.1-2.7 22.5-19.5 39.3-19.6 16.9-.2 31.8 7.4 39.6 18.9-7.7 11.6-22.4 19.5-39.3 19.6-16.9.2-31.7-7.4-39.6-18.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4c839",
    d: "M929.3 1247.6c-16.1 0-31.1-7.2-39.3-19l-.2-.3.3-.1c4.4-1.1 8.9-4.4 13.7-8 7.3-5.4 15.5-11.5 25.6-11.6h.5c16.2 0 31.2 7.2 39.3 19l.1.1-.1.1c-8 12-23.1 19.6-39.5 19.7 0 .1-.2.1-.4.1zm-38.7-18.9c8.2 11.6 23.2 18.7 39.3 18.5 16.2-.1 31.1-7.5 39-19.3-8.1-11.7-23.2-18.8-39.4-18.7-10 .1-18.2 6.1-25.4 11.5-4.7 3.5-9.2 6.8-13.5 8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f8ea14",
    fillRule: "evenodd",
    d: "M885.5 1227.2c15.5-80.4 93-133 173.4-117.6 80.4 15.4 133 93 117.6 173.4-15.5 80.3-93 133-173.4 117.5-80.4-15.3-133-93-117.6-173.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8ea14",
    d: "M1031.4 1403.5c-9.4 0-18.9-.9-28.3-2.7-38.9-7.4-72.6-29.6-94.8-62.4-22.2-32.8-30.4-72.3-22.9-111.1 7.5-38.9 29.7-72.6 62.4-94.8 32.8-22.2 72.3-30.4 111.2-22.9 38.9 7.4 72.6 29.6 94.8 62.4 22.2 32.8 30.4 72.3 22.9 111.2-7.5 38.9-29.7 72.6-62.4 94.8-24.9 16.7-53.6 25.5-82.9 25.5zm-145.7-176.2c-7.4 38.8.7 78.1 22.9 110.8s55.8 54.8 94.6 62.2c9.4 1.8 18.7 2.7 28 2.7 69.4 0 131.6-49.3 145.2-120 7.4-38.8-.7-78.2-22.9-110.9s-55.8-54.8-94.6-62.2c-80.1-15.4-157.8 37.3-173.2 117.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f8cd12",
    fillRule: "evenodd",
    d: "M901.1 1230.1c14.6-76 88.1-125.8 164.2-111.3 76 14.6 125.8 88.1 111.3 164.2-14.6 76-88.1 125.9-164.2 111.3-76.1-14.6-125.9-88.1-111.3-164.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8cd12",
    d: "M1039.1 1397.1c-8.9 0-17.8-.8-26.8-2.6-36.8-7.1-68.7-28.1-89.7-59.1s-28.8-68.4-21.7-105.3c7.1-36.8 28.1-68.7 59.1-89.7s68.4-28.8 105.3-21.7c36.8 7.1 68.7 28.1 89.7 59.1s28.8 68.4 21.7 105.3c-7.1 36.8-28.1 68.7-59.1 89.8-23.5 15.9-50.7 24.2-78.5 24.2zm-137.8-166.9c-14.5 75.8 35.4 149.4 111.1 163.9 8.9 1.7 17.7 2.5 26.4 2.5 65.8 0 124.6-46.7 137.5-113.6 14.5-75.8-35.4-149.3-111.1-163.9-75.9-14.5-149.4 35.3-163.9 111.1z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1038.7 1387.5c72.2 0 131-58.8 131-130.9 0-72.2-58.8-131-131-131-72.1 0-130.9 58.8-130.9 131 0 72.1 58.8 130.9 130.9 130.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1038.7 1387.8c-34.9 0-67.8-13.7-92.6-38.5-24.8-24.8-38.5-57.7-38.5-92.7 0-72.4 58.8-131.2 131.1-131.2 72.4 0 131.2 58.9 131.2 131.2.1 72.3-58.8 131.2-131.2 131.2zm0-262c-72.1 0-130.7 58.7-130.7 130.8 0 72.1 58.6 130.7 130.7 130.7s130.8-58.6 130.8-130.7-58.6-130.8-130.8-130.8z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d48929",
    fillRule: "evenodd",
    d: "M1038.7 1384.7c70.6 0 128.1-57.6 128.1-128.1 0-70.6-57.5-128.1-128.1-128.1-70.5 0-128.1 57.5-128.1 128.1s57.6 128.1 128.1 128.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d48929",
    d: "M1038.7 1384.9c-70.8 0-128.3-57.6-128.3-128.3 0-70.8 57.6-128.3 128.3-128.3s128.3 57.6 128.3 128.3c.1 70.8-57.5 128.3-128.3 128.3zm0-256.2c-70.5 0-127.9 57.4-127.9 127.9s57.4 127.9 127.9 127.9 127.9-57.4 127.9-127.9-57.3-127.9-127.9-127.9z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f8cd12",
    fillRule: "evenodd",
    d: "M1038.7 1382.3c69.3 0 125.7-56.5 125.7-125.7 0-69.3-56.5-125.7-125.7-125.7S913 1187.4 913 1256.6s56.5 125.7 125.7 125.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8cd12",
    d: "M1038.7 1382.6c-33.5 0-65.1-13.1-89-37-23.8-23.8-37-55.4-37-89 0-69.4 56.5-125.9 125.9-125.9s125.9 56.5 125.9 125.9c.2 69.5-56.3 126-125.8 126zm0-251.5c-69.2 0-125.5 56.3-125.5 125.5s56.3 125.5 125.5 125.5 125.5-56.3 125.5-125.5-56.3-125.5-125.5-125.5z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m942 1156.4 2.1 31.5 31.4 2.1-31.4 2.1-2.1 31.4-2.2-31.4-31.3-2.1 31.3-2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m941.7 1223.5-2.1-31.2-31.2-2.1v-.4l31.2-2.1 2.1-31.2h.4l2.1 31.2 31.2 2.1v.4l-31.2 2.1-2.1 31.2h-.4zm-30-33.5 28.4 1.9 1.9 28.4 1.9-28.4 28.4-1.9-28.4-1.9-1.9-28.4-1.9 28.4-28.4 1.9z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1052.9 1280v.3h48.4c1.3 0 2.4 1 2.4 2.4v9.7c0 1.3-1 2.4-2.4 2.4h-48.4v52.7c0 .8-.2 1.4-.6 2-.3.6-1 1-1.9 1.4-1 .3-2.2.6-3.8.9-1.6.2-3.5.3-5.7.3-2.4 0-4.3-.1-5.9-.3-1.5-.2-2.8-.6-3.8-.9-1-.3-1.7-.8-2-1.4-.4-.6-.6-1.2-.6-2v-52.7h-48.4c-1.3 0-2.4-1-2.4-2.4v-9.7c0-1.3 1.1-2.4 2.4-2.4h48.4v-.3l-2.9-5.9h-45.4c-1.3 0-2.4-1.1-2.4-2.4v-9.7c0-1.3 1.1-2.4 2.4-2.4h38.2l-41.5-82.9c-1.1-2.2-1.7-3.9-1.9-5.1-.2-1.2 0-2.2.7-2.8.7-.6 2-1 3.8-1.2 1.8-.2 4.3-.3 7.4-.3 2.8 0 5.1.1 6.8.3 1.7.2 3.2.4 4.2.8 1.1.3 1.8.8 2.4 1.4.5.6 1 1.4 1.5 2.4l25.3 52.6c2.3 5 4.7 10.2 7 15.7s4.7 11 7.1 16.6h.3c2.2-5.4 4.4-10.7 6.7-16 2.3-5.4 4.6-10.6 7-15.8l25.4-52.9c.3-1 .7-1.8 1.2-2.4.6-.7 1.3-1.1 2.2-1.5.9-.3 2.2-.6 3.7-.8 1.6-.2 3.6-.3 6.1-.3 3.4 0 6 .1 8 .3 1.9.2 3.3.7 4.1 1.4.7.7 1 1.6.8 2.8-.2 1.2-.9 2.8-1.9 4.9l-41.5 82.9h38.2c1.3 0 2.4 1.1 2.4 2.4v9.7c0 1.3-1 2.4-2.4 2.4h-45.4l-3.3 5.8z",
    clipRule: "evenodd"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#15489d",
    fillRule: "evenodd",
    d: "M1001.7 1752.2h136.6v184.6h-136.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca99",
    fillRule: "evenodd",
    d: "M1111.8 1759.9c-2.8-12-1.8-24-.1-39.3 15.2-62.7 27.5-179.1 19-191.3-7-12.6-20.5-10-28.8-6.3-.4-11.7 2.1-28.8-1.2-35.2-6.3-8.9-26.3-4.9-26-1-.6-8.2 1.5-19.6-1.7-24.5-12.5-11.3-31.7-4.4-35.9 1.2L1036 1353c-1.5-15.3-29.9-17.2-31.7 1.4-.9 64.3-9.9 145.1-10.9 209.3-24.1-10.6-28.4-45.3-50.6-68-15-15.3-24 5.8-16.3 18.7 21.9 40.4 27 118.3 93.5 205.5 1.8 13.6 2.9 28.9 0 38.4l91.8 1.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8a881",
    fillRule: "evenodd",
    d: "M1111.8 1759.9c-1.7-7.5-2-14.9-1.6-23.2-31.4.4-61.2-5.8-90.3-17l.1.1c1.8 13.6 2.9 28.9 0 38.4l91.8 1.7zM1101.9 1523.2l-.7 39.4c4.3.4 3.7-2.5 3.9-4.7l.5-36.1c-1.3.4-2.6.8-3.7 1.4zM1074.6 1486.4l-.6 61.3c3.7.7 3.7-4 3.9-7.6l.5-56.1c-2.2 1.2-3.7 2.9-3.6 4.5-.2-.7-.2-1.4-.2-2.1zM1037.1 1464.7l-.6 69.5c4 .8 3.7-4.9 3.9-9.2l.4-64.4c-1.7 1.3-3 2.7-3.7 4.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1001.7 1752.2h136.6v25.9h-136.6z",
    clipRule: "evenodd"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f69668",
    fillRule: "evenodd",
    d: "m682.7 1457-13.9-5.3 2.3-18.1 12 1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69668",
    fillRule: "evenodd",
    d: "m672.7 1440.7-3.2-6.1c-2-5-8.6-12.6-5.9-14.8 1.9-1.3 4.4 5.1 7.8 5.3 6.2-2.5 1.1-20.5 6.3-22.2 7.6-2.5 16.6 3.1 16.3 10.8 0 4.2-7.4 14.3-12.3 24.5l-9 2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee4f88",
    fillRule: "evenodd",
    d: "m631.4 1532.3-22.2-23.4 49.4-23.4c2.5-14.7 5.2-29.3 7.8-44 10.9-4.4 14.2.8 21.3 1.2 1.3 23.4-5.3 37.2-8.6 52.4-7.7 18.1-28.2 26.5-47.7 37.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dccde4",
    fillRule: "evenodd",
    d: "m833.5 1350-181.4 71.1c-7.3 2.6-5 11.1 3.8 9.2l188.6-36.8-11-43.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d80bc",
    fillRule: "evenodd",
    d: "M833.5 1350c-5.1 1.4-6.4 12.2-3 24.2 3.3 11.8 10.2 20.3 15.2 18.9 5.1-1.3 6.4-12.1 3.1-24-3.4-12.1-10.2-20.5-15.3-19.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#62caeb",
    fillRule: "evenodd",
    d: "M838 1355.9c-3.5 1-4.4 8.5-2.1 16.7 2.3 8.2 7 14 10.5 13 3.4-.9 4.4-8.4 2.1-16.5-2.3-8.3-7.1-14.1-10.5-13.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69668",
    fillRule: "evenodd",
    d: "m725.7 1455.9-13.9-8.7 6.3-18.9 12.5 4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69668",
    fillRule: "evenodd",
    d: "M718.3 1436.2l-2.2-7.3c-1-5.6-6.5-15.2-3.2-17 2.3-1 3.8 6.3 7.3 7.3 7.1-1.4 5.4-21.8 11.4-22.5 8.8-1.2 17.2 6.8 15.2 15-.8 4.5-11 13.8-18.4 23.7l-10.1.8zM585.2 1870.9l14.6 10.7c5.2 16.5 15.3 26.9 23.7 40l-41-17.8 2.7-32.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69668",
    fillRule: "evenodd",
    d: "m601.9 1847.2-22.8-1.3 3.8 36.4c1.6 4.1 16.8 6.5 17.1-.7l1.9-34.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b174f",
    fillRule: "evenodd",
    d: "M662 1931.3c14.2-11.7-41.2.6-76.1-46.9-1.4-2.4-3.1-2.1-3.2-.1-4.1 17.6-1.7 34-2.4 51l3.3.4c1-8.5 2.1-16.9 3.1-25.4 4.3 9.6 23 21.3 30.8 21.7 6.9 1.1 27-.4 44.5-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69668",
    fillRule: "evenodd",
    d: "m653.4 1874.5 14.6 10.7c5.2 16.5 15.3 26.9 23.6 39.9l-41-17.6 2.8-33z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69668",
    fillRule: "evenodd",
    d: "m669.9 1850.7-22.7-1.3 3.8 36.3c1.6 4.2 16.7 6.6 17.1-.6l1.8-34.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b174f",
    fillRule: "evenodd",
    d: "M730.1 1934.7c14.3-11.6-41.1.6-76-46.9-1.4-2.3-3.1-2.1-3.2-.1-4.1 17.8-1.7 34.1-2.4 51.1l3.2.4c1.1-8.5 2.1-17 3.2-25.4 4.3 9.6 23 21.3 30.8 21.7 6.8 1.1 27-.5 44.4-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15489d",
    fillRule: "evenodd",
    d: "m603.6 1564.6 68.7 63.9c7.4 33.6 16.5 67.3 15.5 88.3l-15.2 143.3c-11.1-.4-22-.9-33.1-1.3l-1.6-136.9-16-49.1-20.4 187.1-34.2-.2 6.1-224.3 30.2-70.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef609a",
    fillRule: "evenodd",
    d: "M581.6 1473.3c13.7-8.3 27.6-16.5 41.3-24.8 13 4.6 33.8 7.5 38.8 13.8 22.7 24.3 16.1 42.1 50.3-27.4 8.2 1.1 12.3 3.8 18.6 10.6-10.4 21.3-13.7 87.8-70 75.3 3.4 44.3 15.1 79.4 18.5 123.8-25.9 25.9-90.5 15.4-109.1 5.1-3.3-59.9 3.1-156.7 11.6-176.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69668",
    fillRule: "evenodd",
    d: "m579.3 1403.4 46.1-17.4c10 27.9 15.8 58.3-3.3 64.2-21.1 6.6-35.5-21.6-42.8-46.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b174f",
    fillRule: "evenodd",
    d: "M620.3 1404.7c8-4.4 11.9-7.3 12.7-15.4 1.6-15.7-13.5-20.3-26.1-16.4-3.9 1.2-9.4 1.8-16.2 4.1-18.7 6.4-21.6 29.2-13.7 43.3 8.5 15.2 11.7 13.1 9.8 31.5-1.9 18.3-21.4 37.1 11.1 49.9 27.8 11 59.1-16.4 35-50.1-8.5-11.9-31.7-26.1-20.4-40.7.9-1.3 7.6-6.1 7.8-6.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69668",
    fillRule: "evenodd",
    d: "m614.3 1427.2.2-10.5c-1.6-3.3-5.5-6.3-8.6-1.9-2.9 5.8 5.6 11 8.4 12.4z",
    clipRule: "evenodd"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#efad8d",
    fillRule: "evenodd",
    d: "M1676.6 754.6l36.2-4.7c3.8 6.3 11.1 16.5 11.4 19 4.9 6.9-33.4 43.8-49.3 62.7l-13.8-24.2c8-12.9 25.3-29.5 25.5-38.1l-10-14.7zM1555.9 754.6l-36.1-4.7c-3.8 6.3-11.2 16.5-11.4 19-4.9 6.9 33.4 43.8 49.3 62.7l13.9-24.2c-8.1-12.9-25.3-29.5-25.6-38.1l9.9-14.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16b79e",
    fillRule: "evenodd",
    d: "m1616.5 860.5-.1-.1-.2.1v-.1l-55.6-6.5-3.1-162.9c8.1-6.9 28.4-13.5 42.3-13.7l16.5 7.1 16.5-7.1c13.9.2 33.2 7.4 42.3 13.7l-1.5 162.7-57.1 6.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e49273",
    fillRule: "evenodd",
    d: "m1632.9 656.6-32.7 3c-.1 9.9-.2 19.7-.2 29.6-.5 12.6 32.4 13.2 32.7.2l.2-32.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efad8d",
    fillRule: "evenodd",
    d: "m1623.6 592-7.2 1.3-7.2-1.3.1 2.7-25.6 4.8c1.7 22.1-.2 57.5 5.2 66.5 5.2 7.9 18.1 10.9 27.5 10.7 9.4.2 22.3-2.9 27.4-10.7 5.4-9 3.5-44.3 5.2-66.5l-25.5-4.8V592z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a164f",
    fillRule: "evenodd",
    d: "M1593.8 601.8c-6.1 2.9-6 20.6-9 30.9-3-17.8-8.6-34.6-2-48.5 3.7-7.9 21.6-15.2 35.7-13.2 7.2.6 13.4 2.2 19.8 5.7 5.1 3.5 5.1 3.8 5.7 7 2.7-1.1 6.7 1.1 9.1 5.1 7 11-2.7 28.3-5.1 44.1-2.6-9.9-.4-28.2-7.9-29.8-6.9-2-19.4 3.3-23.3 3.6-8.9 1.5-15.1-8.2-23-4.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a164f",
    fillRule: "evenodd",
    d: "M1584.5 630.2l1.8-5.5c6.4 22.6-1.3 46.6 29.9 45.3l.1 11c-36.1-7.4-33.7-24.8-31.8-50.8zM1648.3 630.2l-1.7-5.5c-6.5 22.6 1.2 46.6-30 45.3l-.1 11c36.1-7.4 33.6-24.8 31.8-50.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a164f",
    fillRule: "evenodd",
    d: "M1600.1 671.3c2.6-3.5 5.1-9.2 7.5-10.6 1.7-.4 4.3-.3 6.9-.2v.1c.6.1 1.2 0 1.9 0 .6 0 1.2.1 1.8 0v-.1c2.6-.1 5.1-.2 6.9.2 2.5 1.4 5.1 7.1 7.5 10.6l4.2-3.7c-2-3.9-6.6-11.4-9.2-12.5-2.6-.7-7.2-.4-11.2-.3-4-.1-8.7-.4-11.2.3-2.6 1.1-7.2 8.6-9.2 12.5l4.1 3.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#62caeb",
    fillRule: "evenodd",
    d: "M1536.9 778h158.9c.5 0 .9.5.7 1.2-3.6 20-6.9 38.2-9.9 55-2.7 15.5-5.4 29.7-7.7 43-.1.4-.5.7-.9.7h-123.8c-.4 0-.8-.3-.9-.7-2.3-13.3-4.9-27.6-7.5-43-3-16.8-6.2-35-9.7-55-.1-.7.2-1.2.8-1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d80bc",
    fillRule: "evenodd",
    d: "m1700.9 882.3-8.2 25.6c13.2 8.2 26.4 16 39.5 24.3 9.2 5.7 22.9-32.1 11.3-34.4l-42.6-15.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0cae4",
    fillRule: "evenodd",
    d: "M1703.9 906.1l4.4-13.5c.1-.3.4-.4.7-.4l2.1.7c.3.1.5.4.4.7l-4.4 13.5c-.1.2-.4.4-.7.3l-2.1-.7c-.3 0-.5-.3-.4-.6zM1710.6 909.2l4.4-13.5c.1-.3.4-.4.7-.4l2.1.7c.2.1.4.4.3.7l-4.4 13.5c-.1.3-.4.5-.7.4l-2.1-.7c-.2-.1-.3-.4-.3-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efad8d",
    fillRule: "evenodd",
    d: "m1687.7 877.5-9 25.9c4.7 1.4 9.4 2.9 14.1 4.3 7.3-4.5 12.6-18.5 8.1-25.3l-13.2-4.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d80bc",
    fillRule: "evenodd",
    d: "M1528.8 807c-37.5-15.7-66.2 47.6-20.5 59.1l172.4 41.4 10.8-31.1c-53.8-22.4-109-47-162.7-69.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#af96c6",
    fillRule: "evenodd",
    d: "m1531.9 882.3 8.2 25.6c-13.1 8.2-26.4 16-39.5 24.3-9.2 5.7-22.9-32.1-11.2-34.4l42.5-15.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0cae4",
    fillRule: "evenodd",
    d: "M1528.9 906.1l-4.4-13.5c-.1-.3-.4-.4-.7-.4l-2.1.7c-.3.1-.4.4-.4.7l4.4 13.5c.1.2.4.4.7.3l2.1-.7c.3 0 .5-.3.4-.6zM1522.1 909.2l-4.4-13.5c-.1-.3-.4-.4-.7-.4l-2.1.7c-.2.1-.4.4-.3.7l4.4 13.5c.1.3.4.5.7.4l2.1-.7c.3-.1.4-.4.3-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efad8d",
    fillRule: "evenodd",
    d: "m1545 877.5 9 25.9c-4.7 1.4-9.4 2.9-14.1 4.3-7.3-4.5-12.6-18.5-8.1-25.3l13.2-4.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#af96c6",
    fillRule: "evenodd",
    d: "M1704 807c37.5-15.7 66.2 47.6 20.5 59.1l-172.4 41.4-10.8-31.1c53.7-22.4 109-47 162.7-69.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16b79e",
    fillRule: "evenodd",
    d: "M1579.9 721.2c-7.4-10.2-14.7-20.3-22.1-30.4-6.1 6.2-27.2 41.7-40.8 62.5l35.2 9.2 27.7-41.3zM1652.9 721.2c7.4-10.1 14.8-20.3 22.1-30.4 6.2 6.2 27.2 41.7 40.8 62.5l-35.2 9.2-27.7-41.3z",
    clipRule: "evenodd"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#154a9a",
    fillRule: "evenodd",
    d: "m458.8 854.5 10 13.1c17.1 7.1 59.7 9.4 51.2 21.2-23.8.7-47.7 1.3-71.5 2-2.1-5.2-1.4-14.7 2.4-22l7.9-14.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69769",
    fillRule: "evenodd",
    d: "m469.9 831.3-24-.7 5 38.1c3.4 2.1 12.5 4.3 17.9-1.1l1.1-36.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154a9a",
    fillRule: "evenodd",
    d: "m367.7 847 7 14.9c15.2 10.5 56.3 21.8 45.6 31.6-23.4-4.4-46.9-8.8-70.3-13.2-.9-5.5 1.8-14.6 7-21l10.7-12.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69769",
    fillRule: "evenodd",
    d: "m383.4 826.7-23.3-5.8-3.2 38.3c2.9 2.8 11.3 6.9 17.7 2.7l8.8-35.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292a68",
    fillRule: "evenodd",
    d: "m504.6 365.2 13.6-.6c4.5-.2 8.2 3.7 8.2 8.2 0 4.5-3.7 8.1-8.2 8.2l-11.7.1-1.9-15.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdcae5",
    fillRule: "evenodd",
    d: "m512.8 359.5-19.4 1.5c4.9 12.8 6.7 29.1 6.6 37.6 2.3 5.1 8.2 6.2 12.7 5.6v-44.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292a68",
    fillRule: "evenodd",
    d: "m509.2 404.3-5.2-44 8.8-.8v44.8c-1.1.1-2.4.2-3.6 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d7fbc",
    fillRule: "evenodd",
    d: "M517.8 364.6c2 1.9 3.3 4.7 3.3 7.7 0 3.6-1.9 6.8-4.7 8.6l-10 .1-1.9-15.8 13.3-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292a68",
    fillRule: "evenodd",
    d: "M519.8 336.6h-16.1c-8.1 0-14.7 6.6-14.7 14.7s6.6 14.7 14.7 14.7h16.1c8.1 0 14.7-6.6 14.7-14.7 0-8-6.6-14.7-14.7-14.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdcae5",
    fillRule: "evenodd",
    d: "M564.1 303.1c-11.8 13.3-31 29.6-49.1 33.3-11.9 1.8-12.7 24.7 0 29.7 46 9.4 65.3 50.5 49.1-63z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26255d",
    fillRule: "evenodd",
    d: "M568.2 390.3c13.4 0 24.4-20.1 24.4-44.8 0-24.7-10.9-44.8-24.4-44.8-13.4 0-24.4 20.1-24.4 44.8 0 24.7 11 44.8 24.4 44.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdcae5",
    fillRule: "evenodd",
    d: "M568.2 385.9c11.5 0 20.8-18.1 20.8-40.4s-9.4-40.4-20.8-40.4c-11.5 0-20.8 18.1-20.8 40.4s9.3 40.4 20.8 40.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26255d",
    fillRule: "evenodd",
    d: "M546.7 340.6H560v13.6h-13.3c-.2-2.2-.2-4.5-.2-6.8s.1-4.6.2-6.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdcae5",
    fillRule: "evenodd",
    d: "M559.7 354.2c2.3 0 4.1-3.1 4.1-6.8 0-3.8-1.8-6.8-4.1-6.8s-4.1 3.1-4.1 6.8c-.1 3.8 1.8 6.8 4.1 6.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292a68",
    fillRule: "evenodd",
    d: "M559.7 351.9c1.5 0 2.7-2 2.7-4.5s-1.2-4.5-2.7-4.5c-1.5 0-2.7 2-2.7 4.5-.1 2.5 1.2 4.5 2.7 4.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0ae8d",
    fillRule: "evenodd",
    d: "m475.9 465.1 18.7-15.8 15.4 10.5-1.4-63.1 12.5 1.6c1 11.9 14.9 79.3 3.7 86.9-6.2 3.8-32.7-13.4-48.9-20.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1a31",
    fillRule: "evenodd",
    d: "m442.9 504.9 14.6 43.7 14.3 305.6-25.5 1-36.1-307z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#122c4f",
    fillRule: "evenodd",
    d: "m413.7 521.1 15.5 28.2 2.2 132.1-49.2 170.7-26.9-2.3L381 680.7l.3-131.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1bb89e",
    fillRule: "evenodd",
    d: "M434.3 405.6h-20.5c-9.8 4.5-25.5 7-29.4 13.6l-3.9 153.9 78.5.5V419.2c-2.4-5.9-16.5-9.1-24.7-13.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e29374",
    fillRule: "evenodd",
    d: "m412.1 374.8 22.9 11.5c-.1 7.2-.2 14.3-.2 21.4-1.1 11.2-15.9 6.5-21.4 0l-1.3-32.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0ae8d",
    fillRule: "evenodd",
    d: "m402.3 330.7 60.4 6.1c-3.6 18.4-1 47.3-10.8 55.1-12.4 8.2-34.1 4.2-37.4.6-11.8-13.6-8.9-41.4-12.2-61.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b174f",
    fillRule: "evenodd",
    d: "M417.9 337c5.9-4.3 35.6 11.7 44 7.9 20.1-10.4 65.9-18 60.2-31.3-2.1-15.7-62.2.4-95.8-7.3-6.2-1.4-5 4.6-7.5 6.9-9.4 2.7-22.2.2-22.5 9.1-.8 8.5 6.2 36.5 9.3 54.8 7.6-12.1 3.5-36.4 12.3-40.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1bb89e",
    fillRule: "evenodd",
    d: "m436 452.9 21.3-36.1 48.4 38-8.2 24.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0ae8d",
    fillRule: "evenodd",
    d: "m390.4 479.7-21.2.6-2.5 32.7 25.8 75.3 13.4-1.9-18-75.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1bb89e",
    fillRule: "evenodd",
    d: "m405.1 434.4-20.7-15.3c-7.2 8.4-16.3 44.2-16.3 67.1l60 1.1-23-52.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0ae8d",
    fillRule: "evenodd",
    d: "m404 585.3 1.9 1.1 4.8 5-18.8.4.9-5.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m386.3 592.3 30.3-1-.1 4.1-23.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0ae8d",
    fillRule: "evenodd",
    d: "m518.3 413.6 2.7-15.4c-.2-3.6-1-7.8-3.3-10.8-2-5.4-7.2-13.3-18.7-10.9-4.2 3.6-3.6 12.7 0 14.7 1.9 1.8 7.3 4.9 9.5 5.4l9.8 17z",
    clipRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnekey);
export default __webpack_public_path__ + "static/media/onekey.0d60720ce502893c56b42b68820ef7fd.svg";
export { ForwardRef as ReactComponent };